<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">翻译通知（云翻译） </div>
      
      </el-form-item>
      <el-form-item label="AccessKey">
        <el-input v-model="form.AccessKeyId" class="max-w460"></el-input>
         <div class="tips" v-if="!w7">
        <el-link  :underline="false" href="http://pm.y01.cn/v2/pm/login/" target="_blank"
            type="primary">云翻译免费申请</el-link>
             
            </div>
            <div v-else class="tips">
              请联系管理员
            </div>
      </el-form-item>
      <el-form-item label="key">
        <el-input v-model="form.AccessKeySecret" class="max-w460"></el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          AccessKeyId: '',
          AccessKeySecret: ''
        },
        w7:{},
        loading: false,
      };
    },
    created() {
      this.getData()
    },

    methods: {
      // getData() {
      //   let self = this;
      //   SettingApi.TranslateDetail({}, true)
      //     .then(data => {
      //       let vars = data.data.vars.values;
      //       self.form.AccessKeyId = vars.engine.aliyun.AccessKeyId;
      //       self.form.AccessKeySecret = vars.engine.aliyun.AccessKeySecret;
      //     })
      //     .catch(error => {});

      // },

      getData() {
  let self = this;

  // 调用后端API获取翻译配置
  SettingApi.TranslateDetail({}, true)
    .then(response => {
      // 打印完整响应数据，便于调试
      console.log('API响应数据:', response);

      // 逐步解构数据
      const { data } = response;
      console.log('data:', data);

      const { vars } = data;
      console.log('vars:', vars);

      const { values } = vars;
      console.log('values:', values);

      // 检查 values 是否存在
      if (values && values.engine && values.engine.aliyun) {
        // 提取 AccessKeyId 和 AccessKeySecret
        self.form.AccessKeyId = values.engine.aliyun.AccessKeyId || '';
        self.form.AccessKeySecret = values.engine.aliyun.AccessKeySecret || '';
      } else {
        console.warn('返回的数据结构不符合预期:', values);
      }
    })
    .catch(error => {
      // 错误处理
      console.error('获取翻译配置失败:', error);
    });
},
      //提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        let params = this.form;
        SettingApi.editTranslate(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },
      //发送短信
      sendOut() {
        let self = this;
        let params = this.form;
        SettingApi.sendTranslate(params, true)
          .then(data => {
            self.$message({
              message: '恭喜你,发送成功',
              type: 'success'
            });
            self.$router.push('/setting/Sms');

          })
          .catch(error => {

          });
      }



    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/translate/index.vue